import { Box } from "@mui/material";
import PropTypes from "prop-types";
import { useRef } from "react";
import CanvasBoard from "./CanvasBoard";
import { DEFAULT_BOARD_MAT_ID, getBoardMatById, getGrooveStyleForMat } from "./boardMatPalette";
import { normalizeJigsawPiecePaths, resolveJigsawTemplateTileSize } from "./jigsawBrowseUtils";

/**
 * Read-only mini board for library cards — shows pieces the user has placed on the board.
 */
export default function JigsawLibraryBoardPreview({ puzzle }) {
    const boardRef = useRef(null);
    const jigsaw = puzzle?.jigsaw ?? puzzle;
    const grid = resolveJigsawTemplateTileSize(jigsaw) || Number(puzzle?.tileSize) || 0;
    const boardPieces = Array.isArray(puzzle?.boardPositions) ? puzzle.boardPositions : [];
    const paths = normalizeJigsawPiecePaths(jigsaw ?? puzzle);
    const imageUrl = puzzle?.imageUrl ?? null;
    const svgPathFallback = puzzle?.svgPath ?? jigsaw?.svgPath ?? jigsaw?.svg_path ?? null;
    const mat = getBoardMatById(DEFAULT_BOARD_MAT_ID);
    const grooveStyle = getGrooveStyleForMat(mat.hex);
    const total = grid > 0 ? grid * grid : 0;

    if (!grid || !imageUrl || !paths?.length) return null;

    return (
        <Box
            sx={{
                width: "100%",
                aspectRatio: "1 / 1",
                borderRadius: 1,
                overflow: "hidden",
                bgcolor: mat.hex,
                pointerEvents: "none",
            }}
        >
            <CanvasBoard
                boardRef={boardRef}
                boardPieces={boardPieces}
                grid={grid}
                imageUrl={imageUrl}
                paths={paths}
                svgPathFallback={svgPathFallback}
                dragging={null}
                placedCount={boardPieces.length}
                total={total}
                isSolved={total > 0 && boardPieces.length === total}
                showHeader={false}
                fitParent
                readOnly
                matPreset={mat}
                matColor={mat.hex}
                grooveStyle={grooveStyle}
            />
        </Box>
    );
}

JigsawLibraryBoardPreview.propTypes = {
    puzzle: PropTypes.object.isRequired,
};
